import React from 'react';
import Loader from '../../../../../../Components/Loader';
import 'react-toastify/dist/ReactToastify.css';
import { usePageLevelVideoConfigContext } from '../../../../../../Contexts/PageLevelVideoConfigContext';
import PageLevelVideoConfigGenerator from './PageLevelVideoConfigGenerator';
import useStyles from './styles';
import { PLAYLIST_MODES } from '../../../../../../core/constants';
import { Paper } from '@mui/material';
import CreateConfig from './Components/CreateConfig';
import Typography from '@mui/material/Typography';
import PlaylistConfigTableView from './Components/PlaylistConfigTableView';
const PageLevelVideoConfig = () => {
	const classes = useStyles();

	const {
		playlistConfigData,
		playlistConfigMode,
		setPlaylistConfigMode,
		siteId,
		playlistConfigLoading,
		playlistConfigNotFound,
		playlistConfigError,
		handlePlaylistConfigSinglePageSync,
		handlePlaylistConfigBulkPageSync,
		setPlaylistConfigPage
	} = usePageLevelVideoConfigContext();

	if (playlistConfigError) {
		return (
			<Paper className={classes.containerWrapper}>
				<Typography className={classes.heading} fontWeight={600} variant="h3">
					Some error has occured
				</Typography>
			</Paper>
		);
	}
	if (playlistConfigLoading) {
		return <Loader />;
	}
	if (playlistConfigNotFound) {
		return <CreateConfig />;
	}
	if (
		playlistConfigMode === PLAYLIST_MODES.UPDATE_PAGE_VIDEOS ||
		playlistConfigMode === PLAYLIST_MODES.CREATE_PAGE_VIDEOS
	) {
		return <PageLevelVideoConfigGenerator />;
	}

	return (
		playlistConfigData && (
			<PlaylistConfigTableView
				playlistConfigMode={playlistConfigMode}
				pageLevelConfig={playlistConfigData}
				handlePlaylistConfigSinglePageSync={handlePlaylistConfigSinglePageSync}
				handlePlaylistConfigBulkPageSync={handlePlaylistConfigBulkPageSync}
				siteId={siteId}
				setPlaylistConfigMode={setPlaylistConfigMode}
				setPlaylistConfigPage={setPlaylistConfigPage}
			/>
		)
	);
};

export default PageLevelVideoConfig;
